import { Typography, TypographyProps, styled } from "@mui/material";
import { ReactNode, useContext } from "react";
import { ThemeContext } from "../ThemeUsage/ThemeUsage";
import { ThemeValues } from "../ThemeUsage/theme";

interface FormTitleProps extends TypographyProps {
  text: string | ReactNode;
}

const FormTitleStyles = styled(Typography)(({ theme }) => ({
  color: theme.palette.app.secondaryFont,
  fontSize: "22px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "26px",
  whiteSpace: "pre-line",
}));

const FormTitle = ({ text, ...props }: FormTitleProps) => {
  const themeName = useContext(ThemeContext);
  const titleFontFamily =
    themeName === ThemeValues.lichtblick ? "officina" : "isonType";

  return (
    <FormTitleStyles
      variant="h2"
      {...props}
      fontFamily={titleFontFamily}
      mt={2}
    >
      {text}
    </FormTitleStyles>
  );
};

export default FormTitle;
